<template>
  <div id="book-detail" v-if="reading">
    <div class="book-info" style="display: flex;">
      <div class="book-cover">
        <img :src="reading.cover" style="width: 252px;height: 332px;border-radius: 5px;">
      </div>
      <div class="book-info-right" style="margin-left:20px;width: 500px;">
        <el-form>
          <el-form-item label="读本名称">
            <span>{{ reading.name }}</span>
          </el-form-item>
          <el-form-item label="教材简介">
            <div>{{ reading.description }}</div>
          </el-form-item>
          <el-form-item label="创建时间">
            <span>{{ reading.createTime }}</span>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="action-part">
      <el-form :inline="true">
        <el-form-item>
          <el-button type="primary" size="medium" @click="showEditor(null)">创建内容</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="reading-item-list">
      <el-table
          border
          :data="resultList"
          style="width: 100%">
        <el-table-column
            prop="name"
            width="150"
            align="center"
            label="名称">
        </el-table-column>
        <el-table-column
            width="150"
            align="center"
            label="配图">
          <template slot-scope="scope">
            <img :src="scope.row.image" style="border-radius:5px;width: 63px;height: 83px;">
          </template>
        </el-table-column>
         <!-- <el-table-column
            prop="sentence"
            label="句子">
        </el-table-column> -->
        <el-table-column
            prop="ord"
            label="排序"
            align="center"
            width="180">
        </el-table-column>
<!--        <el-table-column-->
<!--            width="180"-->
<!--            align="center"-->
<!--            label="音频">-->
<!--          <template slot-scope="scope">-->
<!--            <el-button @click="playMp3(scope.row)" size="small" type="info">播放</el-button>-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column
            align="center"
            label="关联字">
          <template slot-scope="scope">
            <span v-for="(word,index) in scope.row.words" :key="`${word}-${index}`">{{ word.word }}
              <span v-if="index!==scope.row.words.length-1"> , </span>
            </span>
          </template>
        </el-table-column>
        <el-table-column
            prop="createTime"
            width="180"
            label="创建时间">
        </el-table-column>
        <el-table-column
            align="center"
            width="400"
            label="操作">
          <template slot-scope="scope">
            <el-button type="primary" size="medium" @click="showEditor(scope.row)">编辑</el-button>
            <el-button type="info" size="medium" @click="toReadingQa(scope.row)">问答游戏</el-button>
            <el-popconfirm
                confirm-button-text='马上删除'
                cancel-button-text='我后悔了'
                icon="el-icon-info"
                @confirm="deleteItem(scope.row)"
                icon-color="red"
                title="确定删除该内容吗？">
              <el-button slot="reference" type="danger" style="margin-left: 10px;" size="medium">
                删除
              </el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="dialog-part">
      <el-dialog
          :title="dialogText"
          :visible.sync="isEditorShow"
          center
          width="600px">
        <div>
          <el-form label-width="80px" size="medium">
<!--            <el-form-item label="模块" :required="true">-->
<!--              <el-cascader-->
<!--                  clearable-->
<!--                  v-model="selectModuleIds"-->
<!--                  :options="appModuleTreeData"-->
<!--                  :props="{ checkStrictly: true, value: 'id', label: 'name' }"-->
<!--                  :show-all-levels="true"-->
<!--                  @change="() => {}" placeholder="请选择数据的模块"></el-cascader>-->
<!--            </el-form-item>-->
            <!-- <el-form-item
                label="句子" :required="true">
              <el-input type="textarea" v-model="readingItem.sentence" maxlength="256"
                        :show-word-limit="true"
                        placeholder="请输入句子，建议不超过30个字"></el-input>
            </el-form-item>
            <el-form-item label="音频" :required="true">
              <div class="form-item-container">
                <el-upload
                    accept="audio/mpeg"
                    action=""
                    :show-file-list="false"
                    :http-request="uploadMp3">
                  <el-button type="primary" v-text="readingItem.mp3Id===''?'上传音频':'更新音频'"></el-button>
                  <span class="upload-item-text" v-if="readingItem.mp3Name!==''">{{ readingItem.mp3Name }}</span>
                </el-upload>
              </div>
              <div class="form-des-text">
                MP3格式，大小不超过10M
              </div>
            </el-form-item> -->
            <el-form-item label="名称" :required="true">
              <el-input type="text" v-model="readingItem.name" maxlength="32" :show-word-limit="true" placeholder="请输入名称"></el-input>
            </el-form-item>
            <el-form-item
                label="图片" :required="true">
              <div class="form-item-container">
                <el-upload
                    accept="image/jpeg,image/png,image/jpg"
                    :show-file-list="false"
                    :http-request="uploadReadingItemCover"
                    action="">
                  <div class="reading-cover">
                    <img v-if="readingItem.image" :src="readingItem.image" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </div>
                </el-upload>
              </div>
              <div class="form-des-text">
                支持JPEG/PNG，不超过5M，推荐10:8比例
              </div>
            </el-form-item>
            <el-form-item label="视频" :required="true">
              <div class="form-item-container">
                <el-upload
                    accept="video/mp4"
                    :show-file-list="true"
                    action=""
                    :multiple="true"
                    :file-list="videoFileList"
                    :http-request="uploadVideo"
                    :on-remove="handleVideoRemove">
                  <el-button type="primary">{{ videoFileList.length > 0 ? '上传更多视频' : '上传视频' }}</el-button>
                  <div slot="tip" class="el-upload__tip">MP4格式，每个视频大小不超过100M</div>
                </el-upload>
              </div>
              <div class="form-des-text">
                支持上传多个视频文件
              </div>
            </el-form-item>
            <el-form-item
                label="顺序" :required="true">
              <el-input-number v-model="readingItem.ord" :min="0"></el-input-number>
            </el-form-item>
            <el-form-item label="关联字" :required="false">
              <div v-for="(item, index) in readingItem.words" :key="index" style="display: flex; align-items: center; margin-bottom: 10px;">
                <!-- 文字输入 -->
<!--                <el-input v-model="item.word" placeholder="请输入字" style="width: 120px;"/>-->
                <el-input
                    :value="item.word"
                    @input="(val) => updateWord(val, index)"
                    placeholder="请输入字"
                    style="width: 120px;"
                />

                <!-- 音频上传 -->
                <el-upload
                    accept="audio/mpeg"
                    action=""
                    :show-file-list="false"
                    :http-request="(file) => uploadWordVoice(file, index)"
                    :disabled="!item.word"
                    style="margin-left: 10px;"
                    :before-upload="(file) => beforeUploadWordVoice(file, index)"
                >
                  <el-button type="primary" size="small" :disabled="!item.word">
                    {{ item.voice ? '更新音频' : '上传音频' }}
                  </el-button>
                  <span v-if="item.voice" style="margin-left: 5px;">{{ item.word + '.mp3' }}</span>
                </el-upload>

                <!-- 减号按钮 -->
                <el-button
                    v-if="readingItem.words.length > 1"
                    @click="removeWord(index)"
                    type="danger"
                    icon="el-icon-minus"
                    circle
                    size="small"
                    style="margin-left: 10px;"
                />
              </div>

              <!-- 加号按钮 -->
              <el-button
                  @click="addNewWord"
                  type="primary"
                  icon="el-icon-plus"
                  circle
                  size="small"
              />
            </el-form-item>

          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
                  <el-button @click="onEditorCancel" size="medium">取 消</el-button>
                  <el-button type="primary" @click="onEditorConfirm" size="medium">提 交</el-button>
                </span>
      </el-dialog>
    </div>
    <audio :src="targetPlayUrl" id="audio"></audio>
  </div>
</template>
<script>
import * as api from '../../api/api';
export default {
  data() {
    return {
      readingItem: {
        id: '',
        readingId: '',
        name: '',
        mp3Id: '',
        sentence: '',
        words: [],
        videoList: [],
        ord: 999,
        image: '',
        mp3Name: '',
        moduleId: '0'
      },
      videoFileList: [],
      selectModuleIds: [],
      appModuleTreeData: [],
      reading: {
        description: '',
        createTime: '2025-01-01 12:00:00',
      },
      targetPlayUrl: '',
      readingId: '',
      resultList: [],
      dialogText: '',
      isEditorShow: false,
      inputVisible: true,
      inputValue: ''
    }
  },
  methods: {
    // 删除视频逻辑
    handleVideoRemove(file, fileList) {
      // 从 videoFileList 中找到被删除的文件索引
      const removedIndex = this.videoFileList.findIndex(item => item === file);

      if (removedIndex !== -1) {
        // 获取被删除文件的 videoId
        const removedVideoId = this.videoFileList[removedIndex].videoId;

        // 从 videoFileList 中移除
        this.videoFileList.splice(removedIndex, 1);

        // 同时从 readingItem.videoList 中移除对应的 videoId
        const videoIdIndex = this.readingItem.videoList.indexOf(removedVideoId);
        if (videoIdIndex !== -1) {
          this.readingItem.videoList.splice(videoIdIndex, 1);
        }
      }

      // 更新 fileList
      this.videoFileList = [...fileList];
    },

    // 添加新方法：将视频ID转换为文件列表对象
    async convertVideoIdsToFileList(videoIds) {
      if (!videoIds || videoIds.length === 0) {
        this.videoFileList = [];
        return;
      }

      // 创建临时文件列表用于显示
      this.videoFileList = videoIds.map((videoId, index) => {
        return {
          name: `video_${index + 1}.mp4`, // 可以根据需要自定义文件名
          url: '', // 初始为空，稍后获取临时链接
          videoId: videoId // 保存原始ID用于后续操作
        };
      });

      // 为每个视频ID获取临时访问链接
      for (let i = 0; i < this.videoFileList.length; i++) {
        try {
          const result = await api.getVideoToken(this.videoFileList[i].videoId);
          if (result.code === api.SUCCESS_CODE) {
            this.$set(this.videoFileList[i], 'url', result.data.url);
          }
        } catch (error) {
          console.error('获取视频链接失败:', error);
        }
      }
    },
    getModuleTreeData() {
      api.getAppModuleTree().then(result => {
        if (result.code === api.SUCCESS_CODE) {
          this.appModuleTreeData = result.data;
        }
      })
    },
    beforeUploadWordVoice(file, index) {
      const word = this.readingItem.words[index].word;
      if (!word) {
        this.$message.warning('请先填写文字，再上传音频');
        return false; // 阻止上传
      }
      return true;
    },
    updateWord(value, index) {
      const filtered = value.replace(/[^\u4e00-\u9fa5]/g, '');
      if (filtered.length > 1) {
        this.readingItem.words[index].word = filtered.slice(0, 1);
        this.$message.warning('仅支持输入一个中文字符');
      } else {
        this.readingItem.words[index].word = filtered;
      }
    },

    deleteItem(item) {
      let itemId = item.id;
      api.deleteReadingItem(itemId).then(result => {
        if (result.code === api.SUCCESS_CODE) {
          this.$message.success(result.msg);
          this.listGroup();
        } else {
          this.$message.error(result.msg);
        }
      })
    },
    playMp3(item) {
      let mp3Id = item.mp3Id;
      api.getMp3PlayToken(mp3Id).then(result => {
        if (result.code === api.SUCCESS_CODE) {
          this.targetPlayUrl = result.data.url;
          let audio = document.getElementById('audio');
          if (audio) {
            this.$nextTick(function () {
              audio.play();
            });
          }
        } else {
          this.$message.error(result.msg)
        }
      });
    },
    uploadReadingItemCover(object) {
      let formData = new FormData();
      formData.append('image', object.file);
      api.postReadingCover(formData).then((result) => {
        if (result.code === api.SUCCESS_CODE) {
          let url = result.data;
          this.$message({
            message: '读本封面上传成功.',
            type: 'success',
            center: true
          });
          this.readingItem.image = url;
        } else {
          this.$message.error(result.msg);
        }
      }).catch((err) => {
        console.log(err);
        this.$message({
          message: '读本封面上传出错',
          type: 'error',
          center: true
        })
      })
    },
    onEditorConfirm() {
      this.readingItem.readingId = this.readingId;
      //检查内容
      // if (this.readingItem.sentence === '') {
      //   return this.$message.error("请输入读本句子.");
      // }

      // if (this.readingItem.mp3Id === '') {
      //   return this.$message.error("请上传句子的音频.");
      // }

      if (this.readingItem.image === '') {
        return this.$message.error("请上传配套的图片.");
      }

      if (this.readingItem.videoList === null || this.readingItem.videoList.length === 0) {
        return this.$message.error("请上传配套的视频.");
      }

      // if (!this.readingItem.words.some(w => w.word)) {
      //   return this.$message.error("请至少填写一个有效关联字");
      // }

      const invalidWords = this.readingItem.words.filter(word => word.word && !word.voice);
      if (invalidWords.length > 0) {
        this.$message.error('请为所有已填写的关联字上传对应的音频');
        return;
      }


      this.readingItem.moduleId = this.selectModuleIds[this.selectModuleIds.length - 1];
      if (this.readingItem.id !== '') {
        //更新内容
        api.updateReadingItem(this.readingItem).then(result => {
          if (result.code === api.SUCCESS_CODE) {
            this.listGroup();
            this.onEditorCancel();
            this.$message.success(result.msg)
          } else {
            this.$message.error(result.msg)
          }
        })
      } else {
        //新创建内容
        api.postReadingItem(this.readingItem).then(result => {
          if (result.code === api.SUCCESS_CODE) {
            this.listGroup();
            this.onEditorCancel();
            this.$message.success(result.msg)
          } else {
            this.$message.error(result.msg)
          }
        })
      }
    },
    onEditorCancel() {
      this.isEditorShow = false;
      this.readingItem.id = '';
      this.readingItem.name = '';
      this.readingItem.readingId = '';
      this.readingItem.mp3Id = '';
      this.readingItem.sentence = '';
      this.readingItem.words = [];
      this.readingItem.videoList = [];
      this.readingItem.ord = 0;
      this.readingItem.image = '';
      this.readingItem.mp3Name = '';
    },
    handleInputConfirm() {
      console.log("this.inputValue", this.inputValue)
      if (!this.inputValue) {
        return;
      }
      if (this.inputValue?.length > 1) {
        this.$message.warning("最多只能输入一个字")
        return;
      }

      // 安全访问 readingItem.words
      if (!this.readingItem?.words) {
        console.error("readingItem 或 words 未定义");
        return;
      }

      if (this.readingItem.words.length < 50) {
        this.readingItem.words.push(this.inputValue);
      }

      if (this.readingItem.words.length >= 50) {
        this.inputVisible = false;
      }
      this.inputValue = '';
    },

    handleWordClose(tag) {
      this.readingItem.words.splice(this.readingItem.words.indexOf(tag), 1);
      if (this.readingItem.words.length < 50) {
        this.inputVisible = true;
      }
    },
    uploadMp3(object) {
      let formData = new FormData();
      formData.append('mp3', object.file);
      api.postMp3(formData).then((result) => {
        if (result.code === api.SUCCESS_CODE) {
          let url = result.data;
          this.$message({
            message: 'mp3上传成功.',
            type: 'success',
            center: true
          });
          this.readingItem.mp3Id = url;
          this.readingItem.mp3Name = object.file.name;
        } else {
          this.$message.error(result.msg);
        }
      }).catch((err) => {
        console.log(err);
        this.$message({
          message: '上传mp3出错',
          type: 'error',
          center: true
        })
      })
    },

    uploadVideo(object) {
      let formData = new FormData();
      formData.append('mp4', object.file);
      api.postMp4(formData).then((result) => {
        if (result.code === api.SUCCESS_CODE) {
          let videoId = result.data; // 这里是返回的视频ID
          this.$message({
            message: '视频上传成功.',
            type: 'success',
            center: true
          });
          // 将视频ID添加到列表中
          this.readingItem.videoList.push(videoId);

          // 同时更新显示用的文件列表
          this.videoFileList.push({
            name: object.file.name,
            url: '', // 初始为空
            videoId: videoId
          });

          // 获取该视频的临时访问链接
          api.getVideoToken(videoId).then(tokenResult => {
            if (tokenResult.code === api.SUCCESS_CODE) {
              // 更新文件列表中的URL
              const index = this.videoFileList.findIndex(file => file.videoId === videoId);
              if (index !== -1) {
                this.$set(this.videoFileList[index], 'url', tokenResult.data.url);
              }
            }
          });
        } else {
          this.$message.error(result.msg);
        }
      }).catch((err) => {
        console.log(err);
        this.$message({
          message: '上传视频出错',
          type: 'error',
          center: true
        })
      })
    },

    showEditor(item) {
      this.selectModuleIds = [];
      if (item) {

        api.getReadingItemDetail(item.id).then(result => {
          if (result.code === api.SUCCESS_CODE) {
            this.readingItem = result.data;
            // 将 videoList 中的 ID 转换为文件对象用于显示
            this.convertVideoIdsToFileList(this.readingItem.videoList);
          }
        })
        this.dialogText = '更新内容';
        // this.readingItem.id = item.id;
        // this.readingItem.readingId = item.readingId;
        // this.readingItem.name = item.name;
        // this.readingItem.mp3Id = item.mp3Id;
        // this.readingItem.sentence = item.sentence;
        // this.readingItem.words = !item.words ? [] : item.words;
        // this.readingItem.videoList = item.videoList;
        // this.readingItem.ord = item.ord;
        // this.readingItem.image = item.image;
        // this.readingItem.mp3Name = item.mp3Name;
        this.selectModuleIds.push(item.moduleId)
      } else {
        this.dialogText = '创建内容';
        this.cancelButtonText;// 清空视频文件列表
        this.videoFileList = [];
        this.onEditorCancel();
      }
      this.isEditorShow = true;
    },
    toReadingQa(item) {
      //跳转到问答管理页面
      this.$router.push({
        path: '/word/reading-qa',
        query: {
          readingId: item.readingId,
          readingItemId: item.id,
        }
      })
    },
    listGroup() {
      api.getReadingItem(this.readingId).then(result => {
        if (result.code === api.SUCCESS_CODE) {
          this.resultList = result.data;
        }
      })
    },
    getReadingDetail() {
      api.getReading(this.readingId).then(result => {
        if (result.code === api.SUCCESS_CODE) {
          this.reading = result.data;
          this.listGroup();
        }
      })
    },
    addNewWord() {
      this.readingItem.words.push({word: '', voice: ''});
    },
    removeWord(index) {
      this.readingItem.words.splice(index, 1);
    },
    uploadWordVoice(object, index) {
      let formData = new FormData();
      formData.append('mp3', object.file);

      api.postPubMp3ToUrl(formData).then((result) => {
        if (result.code === api.SUCCESS_CODE) {
          this.$message({
            message: '音频上传成功.',
            type: 'success',
            center: true
          });
          this.readingItem.words[index].voice = result.data.path;
        } else {
          this.$message.error(result.msg);
        }
      }).catch((err) => {
        console.log(err);
        this.$message.error('上传音频出错');
      });
    }


  },
  mounted() {
    this.readingId = this.$route.query.readingId;
    if (this.readingId) {
      this.getReadingDetail();
    }
    this.getModuleTreeData();
  }
}
</script>
<style scoped>
.action-part {
  margin-top: 20px;
}

.reading-cover img {
  width: 200px;
  height: 200px;
  border: 5px;
}

.reading-cover {
  width: 200px;
  height: 200px;
  line-height: 200px;
  border-radius: 5px;
  border: dashed rgba(0, 0, 0, .3) 1px;
}

.el-tag + .el-tag {
  margin-left: 10px;
}

.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}

.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>
